var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c("section", [
        _c(
          "div",
          { staticClass: "d-flex flex-column" },
          [
            _c("section-header", {
              attrs: {
                title: _vm.$t(
                  "apps.accounting.message.journalautomatedaccountsmapping"
                )
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-column",
                staticStyle: { gap: "10px" }
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c("div", { staticClass: "mb-1" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "apps.accounting.label.accountingtransactions"
                            )
                          ) +
                          ":\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-button-group",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              pressed: _vm.selectedDocumentTypes.includes(
                                _vm.KEY_NAME.POS
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleToggleDocumentType(
                                  _vm.KEY_NAME.POS
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  this.$t(
                                    "apps.accounting.journal_mapping.pos_headertitle"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              pressed: _vm.selectedDocumentTypes.includes(
                                _vm.KEY_NAME.INVOICE
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleToggleDocumentType(
                                  _vm.KEY_NAME.INVOICE
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  this.$t(
                                    "apps.accounting.journal_mapping.invoice_headertitle"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              pressed: _vm.selectedDocumentTypes.includes(
                                _vm.KEY_NAME.PURCHASE
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleToggleDocumentType(
                                  _vm.KEY_NAME.PURCHASE
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  this.$t(
                                    "apps.accounting.journal_mapping.purchase_headertitle"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              pressed: _vm.selectedDocumentTypes.includes(
                                _vm.KEY_NAME.EXPENSE
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleToggleDocumentType(
                                  _vm.KEY_NAME.EXPENSE
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  this.$t(
                                    "apps.accounting.journal_mapping.expense_headertitle"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isRender
                  ? _vm._l(_vm.accountingMappingList, function(data, index) {
                      return _c("AccountMapping", {
                        key: index,
                        attrs: {
                          id: data.keyName,
                          keyName: data.keyName,
                          headerTitle: data.headerTitle,
                          headerSubTitle: data.headerSubTitle,
                          itemTitle: data.itemTitle,
                          links: data.links,
                          items: data.items,
                          disabledDebit: data.disabledDebit,
                          disabledCredit: data.disabledCredit,
                          accountMapping: _vm.accountMapping
                        },
                        on: { onChange: _vm.handleItemsChange }
                      })
                    })
                  : _vm._e()
              ],
              2
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02ac6a3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ac6a3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/FormAutomatedAccountsMapping.vue
// module id = null
// module chunks = 